import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import React, { FC, useState } from 'react';
import { NeighborhoodLotsDropdown, FiltersButtons, FiltersLayout } from '../../../components';
import { SalesNeighborhoodDropdown } from '../../../components/dropdowns/sales-neighborhood-dropdown';
import { SalesPlansDropdown } from '../../../components/dropdowns/sales-plans-dropdown';

interface ITenDayBuildsFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  selectedLotId: string;
  selectedPlanId: string;
  setSelectedNeighborhoodId: (val: any) => void;
  setSelectedLotId: (val: any) => void;
  setSelectedPlanId: (val: any) => void;
  selectedNeighborhoodId: string;
  isTenDayComplete: boolean;
  setIsTenDayComplete: React.Dispatch<React.SetStateAction<boolean>>;
}

export const TenDayBuildsFilters: FC<ITenDayBuildsFilters> = ({
  isLoading,
  applyFilters,
  selectedNeighborhoodId,
  selectedLotId,
  selectedPlanId,
  setSelectedNeighborhoodId,
  setSelectedLotId,
  setSelectedPlanId,
  isTenDayComplete,
  setIsTenDayComplete
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <SalesNeighborhoodDropdown
          value={selectedNeighborhoodId}
          handleChange={value => {
            setSelectedNeighborhoodId(value);
          }}
          apiParams={{ hasTenDayBuilds: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <NeighborhoodLotsDropdown
          value={selectedLotId}
          isDisabled={!selectedNeighborhoodId}
          handleChange={value => setSelectedLotId(value)}
          apiParams={{ neighborhoodId: selectedNeighborhoodId }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <SalesPlansDropdown
          isDisabled={isLoading}
          value={selectedPlanId}
          handleChange={val => {
            setSelectedPlanId(val);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormControlLabel
          color="primary"
          control={
            <Checkbox
              checked={isTenDayComplete}
              id="selections-complete-filter"
              color="primary"
              disabled={isLoading}
              onChange={(_, checked) => {
                setIsTenDayComplete(checked);
              }}
            />
          }
          label="Selections Complete"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId('');
            setSelectedLotId('');
            setSelectedPlanId('');
            setIsTenDayComplete(false);
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
